export default __webpack_public_path__ + "static/lnrj-united-logo-bf5d139f034af208077fb0d809636f72.png";